import React from 'react';

const TableTDBatch = ({ field, iseditable, iseditableid, editData, setEditData, handeleditbutton }) => {
    return (
        <th className='py-2 border-0'>
            <div className="input-group flex-nowrap">
                <input 
                    type="number"
                    /* Prevent zoom and improve tap area for iPhone */
                    style={{ fontSize: '16px', touchAction: 'manipulation', minWidth: '50px' }}
                    className="form-control centerplaceholderbatch no-spinner px-1"
                    aria-label={field}
                    placeholder="Enter"
                    value={iseditable === field ? editData[field] : ""}
                    // readOnly={iseditable !== field}
                    onClick={() => handeleditbutton(field, "batch", "inpt")}
                    onChange={(e) => { setEditData({ ...editData, [field]: e.target.value }) }}
                />
                {iseditable === field && (
                    <button
                        className="btn btn-outline-secondary checkbtn px-2"
                        type="button"
                        onClick={() => handeleditbutton(field, "batch", "btn")}
                    >
                        <i className="bi bi-check-lg"></i>
                    </button>
                )}
            </div>
        </th>
    );
}

export default TableTDBatch;